/** Persisted pixel widths for fixed Ads Manager table columns. */

/** v5: campaign 240px / account 130px defaults. */
export const ADS_MANAGER_CAMPAIGN_COL_WIDTH_KEY =
  "adsManagerCampaignColWidthPx_v5"
export const ADS_MANAGER_ACCOUNT_COL_WIDTH_KEY =
  "adsManagerAccountColWidthPx_v5"

export const CAMPAIGN_COL_WIDTH_DEFAULT = 240
export const ACCOUNT_COL_WIDTH_DEFAULT = 130
export const CAMPAIGN_COL_WIDTH_MIN = 100
export const CAMPAIGN_COL_WIDTH_MAX = 560
export const ACCOUNT_COL_WIDTH_MIN = 80
export const ACCOUNT_COL_WIDTH_MAX = 420

export function loadAdsManagerColumnWidth(
  key: string,
  fallback: number,
  min: number,
  max: number,
): number {
  try {
    const raw = globalThis.localStorage?.getItem(key)
    if (raw) {
      const n = Number.parseInt(raw, 10)
      if (Number.isFinite(n)) return Math.min(max, Math.max(min, n))
    }
  } catch {
    /* ignore */
  }
  return fallback
}

export function saveAdsManagerColumnWidth(key: string, width: number): void {
  try {
    globalThis.localStorage?.setItem(key, String(Math.round(width)))
  } catch {
    /* ignore */
  }
}
